/** @enum {string} */
export const Environments = Object.freeze({
  DEV: 'DEV',
  QUOTAS: 'QUOTAS',
  SANDBOX: 'SANDBOX',
  TEST: 'TEST',
  STAGING: 'STAGING',
  PROD: 'PROD',
  NEW_SANDBOX: 'NEW_SANDBOX',
  NEW_STAGING: 'NEW_STAGING',
  OVH05: 'OVH05',
  ANON_DEMO: 'ANON_DEMO'
})
